import UserService from '../../../services/api/User';

/**
 * Get users and send as array
 * @param {Users} callback 
 */
export default function __get_users(callback) {
    let uid = localStorage.getItem('Uid')
    let users = []
    if(uid !== null) {
      UserService.getChatUsers()
      .then((response) => {
        if (response.status === 'SUCCESS') {
          let loggedInUser = JSON.parse(localStorage.getItem("UserProfile"));
          let i;
          for(i = 0; i < response.userDTOS.length; i++  ) {
            if(loggedInUser.email!=null && response.userDTOS[i].email!=null){
              if (loggedInUser.email !== response.userDTOS[i].email) {
                users.push(response.userDTOS[i])
              }            
            }
          }
          callback(users)
      } else {
          // console.log(response.errorMessage);
        }
      });
    }
   
    
}